<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="a-popover">
        <el-popover :placement="placement" :trigger="trigger">
            <template #reference>
                <slot>
                    <a-glyph name="tooltip-icon" />
                </slot>
            </template>

            <div class="popover-content">
                <div v-if="content.title" class="popover-title">
                    {{ content.title }}
                </div>
                <a-dangerous-html
                    v-if="content.content"
                    class="popover-text"
                    :content="content.content"
                />
                <ol v-if="content.list" class="popover-ol">
                    <li
                        v-for="(item, index) in content.list"
                        :key="index"
                        class="popover-list-item"
                    >
                        <a-link v-if="item.to" class="link" v-bind="item" />
                        <div v-else class="popover-text">
                            {{ item.text }}
                        </div>
                    </li>
                </ol>
            </div>
        </el-popover>
    </div>
</template>

<script setup>
import ADangerousHtml from '@core/components/dangerous-html/dangerous-html.vue';
import ElPopover from '@core/components/el-popover/el-popover.vue';
import AGlyph from '@core/components/glyph/glyph.vue';
import ALink from '@core/components/link/link.vue';

defineProps({
    content: { type: Object, required: true },
    placement: { type: String, default: 'top' },
    trigger: { type: String, default: 'click' },
});
</script>

<style lang="postcss">
.a-popover {
    display: inline-block;
    cursor: pointer;

    .el-popover__reference {
        padding: 0;
        background: none;
        font-family: inherit;
        font-weight: inherit;
        font-size: inherit;
        height: auto;
        display: flex;
        align-items: center;
    }
}

.el-popover {
    .a-popper__arrow {
        border: none;
    }

    .popover-content {
        font-weight: 500;
        padding: 16px;
    }

    .popover-title {
        @mixin caption-accent;
        margin-bottom: 8px;
    }

    .popover-text {
        @mixin caption;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    }

    .popover-ol {
        list-style: decimal;
        margin: 0 6px;
    }

    .popover-list-item {
        margin: 0 8px 8px;
    }

    .popover-link {
        @mixin caption;
    }
}
</style>
